/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ConversationEscalationResponse } from './ConversationEscalationResponse';

/**
 * A conversation
 */
export type ConversationResponse = {
    /**
     * Conversation ID
     */
    id: string;
    /**
     * Conversation title
     */
    title?: string;
    /**
     * Conversation summary
     */
    summary?: string;
    /**
     * Conversation status
     */
    status: ConversationResponse.status;
    /**
     * Escalations for this conversation
     */
    escalations: Array<ConversationEscalationResponse>;
    /**
     * Number of unread messages in this conversation
     */
    unreadMessageCount: number;
    /**
     * When the conversation was created
     */
    createdAt: string;
    /**
     * When the conversation was last updated
     */
    updatedAt: string;
};

export namespace ConversationResponse {

    /**
     * Conversation status
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        CLOSED = 'CLOSED',
    }


}

